// src/components/Header.jsx
import React from 'react';
import { Flex, Box, Heading } from '@chakra-ui/react';
import LogoutButton from './LogoutButton';

export default function Header({ title }) {
  return (
    <Flex
      as="header"
      w="100%"
      align="center"
      justify="space-between"
      px={6}
      py={4}
      borderBottom="1px solid"
      borderColor="gray.200"
      mb={6}
      position="sticky"
      top="0"
      bg="white"
      zIndex="banner"
    >
      {title ? <Heading size="md">{title}</Heading> : <Box />}
      <LogoutButton />
    </Flex>
  );
}
